// extracted by mini-css-extract-plugin
export default {"formHeading":"IH-z","form":"JH-z","submitBtn":"KH-z","disabled":"LH-z","input":"MH-z","error":"NH-z","submitMsg":"OH-z","signIn":"PH-z"};